import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    NUMERIC_RANGE_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE
} from "../../helpers/constants";
import { formatCurrency } from "../../components/common/PriceDisplay";
import { AgreementPassportButton } from "../AgreementsPage/AgreementPassportDialog/AgreementPassportButton";
import {Typography} from "@mui/material";
import DateService from "../../services/dateService";

export const AGREEMENT_FINANCIAL_REPORT_TABLE_NAME = "agreement_financial_report_table";

export const useAgreementFinancialReportTableConfig = () => {
    const { t } = useTranslation();

    const boolToString = (value) => (value ? t("yes") : t("no"));

    return [
        {
            name: "agreement_nr",
            getValueCallback: (rowData) => rowData.agreement_nr,
            label: t("table.agreements.agreementNr"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_customer",
            getValueCallback: (rowData) => rowData.agreement_customer,
            label: t("table.agreements.customers"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_notarial_dead",
            getValueCallback: (rowData) => rowData.agreement_notarial_dead,
            label: t("table.agreements.agreementNotarialDeed"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_date_signed",
            getValueCallback: (rowData) => rowData.agreement_date_signed,
            label: t("table.agreements.agreementDateSigned"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_number",
            getValueCallback: (rowData) => rowData.local_number,
            label: t("table.agreements.localNumber"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_footage",
            getValueCallback: (rowData) => rowData.local_footage,
            label: t("table.agreements.localFootage"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_price_net",
            getValueCallback: (rowData) => formatCurrency(rowData.local_price_net),
            label: t("table.agreements.localPriceNet"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_price_gross",
            getValueCallback: (rowData) => formatCurrency(rowData.local_price_gross),
            label: t("table.agreements.localPriceGross"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "box_number",
            getValueCallback: (rowData) => rowData.box_number,
            label: t("table.agreements.boxNumber"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "box_footage",
            getValueCallback: (rowData) => rowData.box_footage,
            label: t("table.agreements.boxFootage"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "box_price_net",
            getValueCallback: (rowData) => formatCurrency(rowData.box_price_net),
            label: t("table.agreements.boxPriceNet"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "box_price_gross",
            getValueCallback: (rowData) => formatCurrency(rowData.box_price_gross),
            label: t("table.agreements.boxPriceGross"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "parking_spaces_number",
            getValueCallback: (rowData) => rowData.parking_spaces_number,
            label: t("table.agreements.parkingSpacesNumber"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "parking_spaces_count",
            getValueCallback: (rowData) => rowData.parking_spaces_count,
            label: t("table.agreements.parkingSpacesCount"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "parking_spaces_price_net",
            getValueCallback: (rowData) => formatCurrency(rowData.parking_spaces_price_net),
            label: t("table.agreements.parkingSpacesPriceNet"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "parking_spaces_price_gross",
            getValueCallback: (rowData) => formatCurrency(rowData.parking_spaces_price_gross),
            label: t("table.agreements.parkingSpacesPriceGross"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_price_net",
            getValueCallback: (rowData) => formatCurrency(rowData.total_price_net),
            label: t("table.agreements.totalPriceNet"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_price",
            getValueCallback: (rowData) => formatCurrency(rowData.total_price),
            label: t("table.agreements.totalPrice"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_individual_transfers",
            getValueCallback: (rowData) => formatCurrency(rowData.total_individual_transfers),
            label: t("table.agreements.totalIndividualTransfers"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_footage_postconstruction",
            getValueCallback: (rowData) => rowData.local_footage_postconstruction,
            label: t("table.agreements.localFootagePostconstruction"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "box_footage_postconstruction",
            getValueCallback: (rowData) => rowData.box_footage_postconstruction,
            label: t("table.agreements.boxFootagePostconstruction"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_price_net_after_final_settlement",
            getValueCallback: (rowData) => formatCurrency(rowData.total_price_net_after_final_settlement),
            label: t("table.agreements.totalPriceNetAfterFinalSettlement"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_price_after_final_settlement",
            getValueCallback: (rowData) => formatCurrency(rowData.total_price_after_final_settlement),
            label: t("table.agreements.totalPriceAfterFinalSettlement"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_price_final_settlement_difference",
            getValueCallback: (rowData) => formatCurrency(rowData.total_price_final_settlement_difference),
            label: t("table.agreements.totalPriceFinalSettlementDifference"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_is_operator",
            getValueCallback: (rowData) => boolToString(rowData.agreement_is_operator),
            label: t("table.agreements.agreementIsOperator"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "local_style",
            getValueCallback: (rowData) => rowData.local_style,
            label: t("table.agreements.localStyle"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "banking_nr",
            getValueCallback: (rowData) => rowData.banking_nr,
            label: t("table.agreements.bankingNr"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "reservation_agreement_nr",
            getValueCallback: (rowData) => rowData.reservation_agreement_nr,
            label: t("table.agreements.reservationAgreementNr"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_is_customer_jdg",
            getValueCallback: (rowData) => boolToString(rowData.agreement_is_customer_jdg),
            label: t("table.agreements.agreementIsCustomerJdg"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_is_customer_nip",
            getValueCallback: (rowData) => boolToString(rowData.agreement_is_customer_nip),
            label: t("table.agreements.agreementIsCustomerNip"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "reservation_payment_amount",
            getValueCallback: (rowData) => formatCurrency(rowData.reservation_payment_amount),
            label: t("table.agreements.agreementPaymentAmount"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "reservation_payment_is_paid",
            getValueCallback: (rowData) => boolToString(rowData.reservation_payment_is_paid),
            label: t("table.agreements.reservationPaymentIsPaid"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "total_invoices",
            getValueCallback: (rowData) => formatCurrency(rowData.total_invoices),
            label: t("table.agreements.totalInvoices"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "remaining_amount",
            getValueCallback: (rowData) => formatCurrency(rowData.remaining_amount),
            label: t("table.agreements.remainingAmount"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_broker_name",
            getValueCallback: (rowData) => rowData.agreement_broker_name,
            label: t("table.agreements.agreementBrokerName"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_broker_percentage",
            getValueCallback: (rowData) => rowData.agreement_broker_percentage,
            label: t("table.agreements.agreementBrokerPercentage"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "agreement_broker_amount",
            getValueCallback: (rowData) => formatCurrency(rowData.agreement_broker_amount),
            label: t("table.agreements.agreementBrokerAmount"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
       {
            name: "reservation_payment_invoice_number",
            getValueCallback: (rowData) => rowData.reservation_payment_invoice_number,
            label: t("table.agreements.reservationPaymentInvoiceNumber"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        // {
        //     name: "agreement_passport",
        //     getValueCallback: (rowData) => <AgreementPassportButton agreement={{id:rowData.agreement_id}} />,
        //     label: t("table.agreements.agreementPassport"),
        //     getFilterFieldConfigCallback: () => undefined,
        //     sortable: false,
        //     excludedFromExport: true,
        //     headerSx: { whiteSpace: "break-spaces" },
        // },
    ];
};
